import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useCommunity } from "./CommunityContext";


const DynamicMeta: React.FC = () => {
  const {meta} = useCommunity();

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      {meta.favicon && <link rel="shortcut icon" type="image/x-icon" href={meta.favicon} />}
    </Helmet>
  );
};

export default DynamicMeta;